import React, { useEffect, useState } from 'react';
import TextfieldInput from '../../Shared/TextField';
import { Grid2, Select, MenuItem, DialogTitle, DialogContentText, DialogContent, DialogActions, Dialog, Box } from '@mui/material';
import ButtonNormalText from '../../Shared/Buttons/ButtonNormalText';
import ButtonNormalDelete from '../../Shared/Buttons/ButtonNormalDelete';
import { dataService } from '../../../Services/data/data.service';
import { useNavigate, useParams } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import TableList from './Components/TableModifyList';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Save, Trash2 } from 'lucide-react';
import Button from '../../Shared/Buttons/Button';
import HeaderBar from '../../Shared/Header/HeaderBar';
import HeaderTitle from '../../Shared/Header/HeaderTitle';
import Breadcrumb from '../../Shared/Header/Breadcrumb';
import CustomCheckbox from '../../Shared/Checkbox';
import { useTranslation } from 'react-i18next';

function ModifyListPage(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dropdownUniqueId = useParams().dropdownUniqueId;

    const [listName, setListName] = useState("");
    const [listCompany, setListCompany] = useState(null);
    const [companyId, setCompanyId] = useState(null);
    const [allUserCompanies, setAllUserCompanies] = useState([]);
    const [listDescription, setListDescription] = useState("");
    const [helperTextListName, setHelperTextListName] = useState(null);
    const [helperTextListCompany, setHelperTextListCompany] = useState(null);
    const [errorListName, setErrorListName] = useState(false);
    const [errorListCompany, setErrorListCompany] = useState(false);
    const [emptyDetails, setEmptyDetails] = useState(false);
    const [listItems, setListItems] = useState([]);
    const [delopen, setDelOpen] = useState(false);
    const [listId, setListId] = useState(0);
    var today = new Date();

    const [isMultiSelect, setIsMultiSelect] = useState(false);

    useEffect(() => {
        dataService.getDataListByUniqueId(dropdownUniqueId).then(results => {
            setListDescription(results.description)
            setListName(results.name);
            setIsMultiSelect(results.isMultiSelect);
            setListItems([...results.dataListItems.map(x => ({ Id: x.id, itemName: x.name, itemDescription: x.description, InsertedOn: x.insertedOn, InsertedByUserId: x.insertedByUserId, edit: false }))]);
            setListId(results.id)
            setCompanyId(results.companyId)
        })
    }, [props.Login.userid, dropdownUniqueId, props.Login.userid]);

    useEffect(() => {
        if (companyId) {
            dataService.getAllCompaniesByUserId(props.Login.userid).then(results => {
                setListCompany(results.find(x => x.id === companyId))
                setAllUserCompanies(results);
            })
        }
    }, [companyId, props.Login.userid])

    const handleDialogOpenDel = () => {
        setDelOpen(true);
    }
    const handleDialogCloseDel = () => {
        setDelOpen(false);
    }

    const handleDeleteList = () => {
        let userid = props.Login.userid
        let DataListItems = listItems.map(x => ({ Name: x.itemName, Description: x.itemDescription, InsertedOn: x.InsertedOn, InsertedByUserId: x.UserId, Id: x.Id }));
        dataService.deleteDataList(listName, listDescription, listCompany.id, isMultiSelect, today, userid, DataListItems, listId).then(response => {
            if (response.success === true) {
                toast.success(t('modifyList.deleteSuccess'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            } else {
                toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            }

        });
        navigate("/dropdownoverview");
    }

    const setList = (event) => {
        setListName(event.target.value);
    }

    const setDescription = (event) => {
        setListDescription(event.target.value);
    }

    const saveAllListItems = () => {
        let invalidRowsCount = 0;
        let tempListItems = [...listItems];

        tempListItems.forEach(listItem => {
            if (listItem.itemName === "") {
                invalidRowsCount++;
            }
        })

        if (invalidRowsCount == 0) {
            tempListItems = tempListItems.map(listItem => ({
                ...listItem, // Spread the existing properties
                edit: false // Override the 'edit' property
            }));

            setListItems(tempListItems);
            return true;
        } else {
            return false;
        }
    }

    const sendToApi = () => {
        if (listName === "") {
            setHelperTextListName(t('modifyList.enterDropdownName'))
            setErrorListName(true)
        }
        if (!listCompany) {
            setHelperTextListCompany(t('modifyList.selectCompany'))
            setErrorListCompany(true);
        }
        else {
            setHelperTextListName(null)
            setErrorListName(false)
            setEmptyDetails(false)
            if (listItems.length === 0) {
                setEmptyDetails(true)
            }
            else {
                if (saveAllListItems()) {
                    // API CALL HERE
                    let userid = props.Login.userid
                    let DataListItems = listItems.map(x => ({ Name: x.itemName, Description: x.itemDescription, InsertedOn: x.InsertedOn, InsertedByUserId: x.InsertedByUserId, Id: x.Id, State: x.state }));
                    dataService.modifyDataList(listName, listDescription, listCompany.id, isMultiSelect, today, userid, DataListItems, listId).then((response) => {
                        if (response.success === true) {
                            toast.success(t('modifyList.saveSuccess'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                        } else {
                            toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                        }
                    });
                } else {
                    toast.error(t('modifyList.itemsNeedName'), { position: toast.POSITION.TOP_CENTER })
                }
            }
        }
    }

    return (
        <React.Fragment>
            <Box className="page-container">
                <HeaderBar>
                    <Breadcrumb onClick={() => navigate('/dropdownoverview')}>{t('modifyList.dropdowns')}</Breadcrumb>
                    <HeaderTitle>{t('modifyList.pageTitle')}</HeaderTitle>
                </HeaderBar>

                <Box className={classes.container}>
                    <Box className={classes.projectSelectionContainer}>
                        <div className={classes.formContainer}>
                            <div className={classes.formColumn}>
                                <div className={classes.projectOption}>
                                    <div className={classes.projectOption__labelContainer}>
                                        {!helperTextListName ?
                                            <p className={classes.labelContainer__label}>{t('modifyList.dropdownName')}</p>
                                            :
                                            <p className={classes.labelContainer__helperText}>{helperTextListName}</p>
                                        }
                                    </div>
                                    <div className={classes.projectOption__inputContainer}>
                                        <TextfieldInput value={listName} action={setList} label={listName ? " " : t('modifyList.dropdown')} InputLabelProps={{ shrink: false }} error={errorListName} />
                                    </div>
                                </div>
                                <div className={classes.projectOption}>
                                    <div className={classes.projectOption__labelContainer}>
                                        {!helperTextListCompany ?
                                            <p className={classes.labelContainer__label}>{t('modifyList.selectCompany')}</p>
                                            :
                                            <p className={classes.labelContainer__helperText}>{helperTextListCompany}</p>
                                        }
                                    </div>
                                    <div className={classes.projectOption__inputContainer}>
                                        <Select
                                            value={listCompany}
                                            onChange={(e) => setListCompany(e.target.value)}
                                            displayEmpty
                                            error={errorListCompany}
                                            style={{ width: "100%" }}
                                            renderValue={listCompany !== "" ? undefined : () => t('modifyList.company')}
                                        >
                                            {/* If no company is selected, this is a placeholder */}
                                            {allUserCompanies.length < 1 &&
                                                <MenuItem value="">
                                                    <em>{t('modifyList.notPartOfCompany')}</em>
                                                </MenuItem>
                                            }
                                            {/* Populate the dropdown with companies from allUserCompanies */}
                                            {allUserCompanies.map((company, index) => (
                                                <MenuItem key={index} value={company}>
                                                    {company.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </div>

                                    <div className={classes.projectOption__checkboxContainer}>
                                        <CustomCheckbox label={t('modifyList.multiSelectList')} checked={isMultiSelect} onChange={setIsMultiSelect} indeterminate={false} disabled={false} />
                                    </div>
                                </div>
                            </div>
                            <div className={classes.listDescriptionStyle}>
                                <div className={classes.projectOption__labelContainer}>
                                    <p className={classes.labelContainer__label}>{t('modifyList.dropdownDescription')}</p>
                                </div>
                                <textarea className={classes.description__textarea} value={listDescription} onChange={(e) => setDescription(e)}></textarea>
                                {/* <TextfieldInput rows={3} multiline value={listDescription} action={setDescription} label={listDescription ? " " : "Description"} InputLabelProps={{ shrink: false }} /> */}
                            </div>
                        </div>
                    </Box>
                    {emptyDetails === true ?
                        <div style={{ marginTop: "1rem" }}>
                            <Grid2 item xs={12} sm={12} md={12} style={{ border: "solid 2px", borderColor: "#d32f2f", borderRadius: "17px" }}>
                                <TableList {...props} rows={listItems} setRows={setListItems} makeSave={sendToApi} />
                            </Grid2>
                            <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>{t('modifyList.createAtLeastOneItem')}</p>
                        </div>
                        :
                        <div style={{ marginTop: "1rem" }}>
                            <Grid2 item xs={12} sm={12} md={12}>
                                <TableList {...props} rows={listItems} setRows={setListItems} />
                            </Grid2>
                        </div>}
                    <Box className={classes.buttonContainer}>
                        <Button variant="destructive" startIcon={<Trash2 absoluteStrokeWidth />} onClick={handleDialogOpenDel}>
                            {t('common.delete')}
                        </Button>
                        <Button startIcon={<Save absoluteStrokeWidth />} onClick={sendToApi}>
                            {t('common.save')}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {delopen &&
                <Dialog
                    open={delopen}
                    onClose={handleDialogCloseDel}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('modifyList.deleteDropdown')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {t('modifyList.deleteConfirm', { name: listName })}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonNormalText content={t('common.close')} onClick={handleDialogCloseDel}>{t('common.close')}</ButtonNormalText>
                        <ButtonNormalDelete startIcon={<Trash2 />} content={t('common.delete')} onClick={handleDeleteList}>{t('common.delete')}</ButtonNormalDelete>
                    </DialogActions>
                </Dialog>
            }

        </React.Fragment>
    )
}

export default ModifyListPage;
const useStyles = makeStyles((theme) => ({
    projectSelectionContainer: {
        width: "100%",
        boxSizing: "border-box",

        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: "8px",
        marginBottom: "16px",
        padding: "16px",
    },

    qrButton: {
        backgroundColor: "var(--color-primary)"
    },
    buttonContainer: {
        gap: "8px",
        justifyContent: 'end',
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        float: 'right'
    },

    description__textarea: {
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        padding: "8px",
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        backgroundColor: "transparent",
        border: "1px solid #BDBDBD",
        borderRadius: "4px",
        resize: "none",

        [theme.breakpoints.down('sm')]: {
            height: "120px",
        },
    },

    projectOption: {
        minWidth: "240px",
        maxWidth: "100%",

        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },

    projectOption__labelContainer: {
        display: "flex",
        gap: "8px",
    },

    labelContainer__label: {
        fontSize: "16px",
        color: "rgb(105, 105, 105)",
        margin: 0
    },

    labelContainer__helperText: {
        fontSize: "15px",
        color: "red"
    },

    projectOption__checkboxContainer: {
        height: "56px",
        width: "100%",

        display: "flex",
        alignItems: "center",

        padding: "0px 12px",
        marginTop: "8px",

        borderRadius: "4px",
        border: "1px solid #adb5bd",

    },

    formContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "16px",

        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
            gap: "8px",
        },
    },

    formColumn: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },

    listDescriptionStyle: {
        width: '100%',

        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },

    primaryButton: {
        height: "40px",
        padding: "0 16px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        transition: "all 0.2s ease-in-out",
        whiteSpace: "nowrap",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            cursor: "pointer",
        }
    },

    disabledIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",
        border: "none",
        borderRadius: "4px",
        fontSize: "16px",
        color: "white",
        backgroundColor: "#DCDCDC",
        display: "flex",
        gap: "8px",
        alignItems: "center",
        "&:hover": {
            cursor: "not-allowed",
        }
    },

    deleteButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",
        border: "1px solid #D84949",
        borderRadius: "4px",
        fontSize: "16px",
        color: "#D84949",
        backgroundColor: "transparent",
        display: "flex",
        gap: "8px",
        alignItems: "center",
        transition: "all 0.2s ease-in-out",

        "&:hover": {
            border: "1px solid #D84949",
            backgroundColor: "#D84949",
            color: "white",
            cursor: "pointer",
        }
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },
}));